module.exports = __webpack_public_path__ + "img/computer.f1d73a24.png";